export default __webpack_public_path__ + "static/media/two-men-class.ad555d5d.jpg";